import * as api from "@/apiv2/collaborateLabels";
import { handleError } from "@/redux/utils/error";

import {
  RESET,
  SET_ACTIVE_LABEL,
  SET_IS_CREATE_LABEL_FORM_VISIBLE,
  SET_IS_DELETE_LABEL_ALERT_VISIBLE,
  SET_IS_FETCHING_LABELS,
  SET_IS_LABELS_DROPDOWN_VISIBLE,
  SET_IS_SAVING_LABEL,
  SET_LABELS,
  SET_SELECTED_LABELS,
  SET_UNSELECTED_LABELS,
} from "./collaborateLabels.actionTypes";
import * as selectors from "./collaborateLabels.selectors";

export const reset = () => (dispatch) => {
  dispatch({
    type: RESET,
  });
};

export const setIsLabelsDropdownVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_LABELS_DROPDOWN_VISIBLE,
    payload: status,
  });
};

export const setIsSavingLabel = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_SAVING_LABEL,
    payload: status,
  });
};

export const setIsFetchingLabels = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_FETCHING_LABELS,
    payload: status,
  });
};

export const setLabels = (data) => (dispatch) => {
  dispatch({
    type: SET_LABELS,
    payload: data,
  });
};

export const setSelectedLabels = (data) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_LABELS,
    payload: data,
  });
};

export const setUnSelectedLabels = (data) => (dispatch) => {
  dispatch({
    type: SET_UNSELECTED_LABELS,
    payload: data,
  });
};

export const setActiveLabel = (data) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_LABEL,
    payload: data,
  });
};

export const setIsDeleteLabelAlertVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_DELETE_LABEL_ALERT_VISIBLE,
    payload: status,
  });
};

export const setIsCreateLabelFormVisible = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_CREATE_LABEL_FORM_VISIBLE,
    payload: status,
  });
};

export const toggleLabels = (uid) => (dispatch, getState) => {
  const state = getState();
  const selectedLabelUids = selectors.getSelectedLabels(state) || [];
  const unSelectedLabelUids = selectors.getUnSelectedLabels(state) || [];

  if (selectedLabelUids.includes(uid) && !unSelectedLabelUids.includes(uid)) {
    dispatch(setUnSelectedLabels([...unSelectedLabelUids, uid]));
  }

  if (!selectedLabelUids.includes(uid)) {
    dispatch(setSelectedLabels([...selectedLabelUids, uid]));
  }
};

export const saveLabel = (data) => async (dispatch) => {
  dispatch(setIsSavingLabel(true));
  try {
    const token = JSON.parse(localStorage.getItem("auth"));
    let response;

    if (data.uid) {
      // Update existing label
      response = await api.updateLabel(data.uid, data)(token);
    } else {
      // Create new label
      response = await api.createLabel(data)(token);
    }

    await dispatch(fetchLabels());

    return response.data;
  } catch (error) {
    handleError(error, dispatch);
    throw error;
  } finally {
    dispatch(setIsSavingLabel(false));
  }
};

export const fetchLabels = () => async (dispatch) => {
  dispatch(setIsFetchingLabels(true));
  try {
    const token = JSON.parse(localStorage.getItem("auth"));
    const response = await api.getLabels()(token);
    dispatch(setLabels(response.data));
  } catch (error) {
    handleError(error, dispatch);
  } finally {
    dispatch(setIsFetchingLabels(false));
  }
};

// export const assignLabelsToOrder = (data) => async (dispatch) => {
//   // This would need to be implemented for message labels
//   // For now, just a placeholder for compatibility
// };

export const removeLabel = (uid) => async (dispatch) => {
  try {
    const token = JSON.parse(localStorage.getItem("auth"));
    await api.deleteLabel(uid)(token);

    // Always fetch the complete list of labels after deletion
    // This ensures the Redux state has the complete, up-to-date list
    await dispatch(fetchLabels());
  } catch (error) {
    handleError(error, dispatch);
    throw error;
  }
};

export const attachLabelToMessage = (messageId, labelUid) => async (dispatch) => {
  try {
    const token = JSON.parse(localStorage.getItem("auth"));
    const response = await api.postLabelToMessage(messageId, labelUid)(token);
    return response.data;
  } catch (error) {
    handleError(error, dispatch);
    throw error;
  }
};

export const attachLabelToFile = (messageId, labelUid, fileId) => async (dispatch) => {
  try {
    const token = JSON.parse(localStorage.getItem("auth"));
    const response = await api.postLabelToFile(messageId, labelUid, fileId)(token);
    return response.data;
  } catch (error) {
    handleError(error, dispatch);
    throw error;
  }
};

export const detachLabelFromMessage = (attachmentId) => async (dispatch) => {
  try {
    const token = JSON.parse(localStorage.getItem("auth"));
    const response = await api.deleteLabelFromMessage(attachmentId)(token);
    return response.data;
  } catch (error) {
    handleError(error, dispatch);
    throw error;
  }
};
